import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatchDetailSectionViewModel, SelectionToggleRequest } from '../sportsbook/sportsbook.models';
import { OddsValueFlashDirective } from '../shared/odds-value-flash.directive';

@Component({
  selector: 'app-match-detail-market-group',
  standalone: true,
  imports: [CommonModule, OddsValueFlashDirective],
  templateUrl: './match-detail-market-group.component.html',
  styleUrl: './match-detail-market-group.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MatchDetailMarketGroupComponent {
  readonly section = input.required<MatchDetailSectionViewModel>();
  readonly matchId = input.required<number>();
  readonly selectionToggle = output<SelectionToggleRequest>();

  protected readonly trackOption = (_: number, option: MatchDetailSectionViewModel['options'][number]): string => option.key;

  protected onSelectionClick(option: MatchDetailSectionViewModel['options'][number]): void {
    this.selectionToggle.emit({
      matchId: this.matchId(),
      betTypeId: option.betTypeId,
      oddId: option.oddId
    });
  }
}
